"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _form = require("@clayui/form");

var _loadingIndicator = _interopRequireDefault(require("@clayui/loading-indicator"));

var _react = _interopRequireDefault(require("react"));

var _Context = require("./Context");

var _excluded = ["children"],
    _excluded2 = ["className", "component"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LoadingIndicatorMarkup = function LoadingIndicatorMarkup(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupInsetItem, _extends({}, otherProps, {
    after: true
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "inline-item inline-item-middle"
  }, children));
};

var ClayAutocompleteLoadingIndicator = function ClayAutocompleteLoadingIndicator(_ref2) {
  var className = _ref2.className,
      _ref2$component = _ref2.component,
      Component = _ref2$component === void 0 ? LoadingIndicatorMarkup : _ref2$component,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  var _React$useContext = _react.default.useContext(_Context.LegacyContext),
      onLoadingChange = _React$useContext.onLoadingChange;

  _react.default.useEffect(function () {
    onLoadingChange(true);
    return function () {
      onLoadingChange(false);
    };
  }, []);

  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, otherProps, {
    className: className
  }), /*#__PURE__*/_react.default.createElement(_loadingIndicator.default, {
    small: true
  }));
};

var _default = ClayAutocompleteLoadingIndicator;
exports.default = _default;